import styled from 'styled-components';
import { StockModelListStyled } from '../StockModelListStyled';
import { rem } from 'polished';

export const StockModelListStyledAC = styled(StockModelListStyled)`
    border: none;
    
    .last-item-wrapper {
        .last-item-banner-container-button {
            button {
                font-size: ${({ theme }) => theme.fontSizes.h4};
                font-weight: ${({ theme }) => theme.fontWeights.textBold};
                background: ${({ theme }) => theme.colors.blue2};
                border-radius: ${rem(24)};
                &:hover {
                    background-color: ${({ theme }) => theme.colors.grey5};
                }
            }
        }
    }
`;
